export default {
  name: "details",
  data: function data() {
    return {
      currentTableData: [],
      loading: false
    };
  }
};